import React from "react";
import { FullscreenDisableIconComponent } from "../../..//icons/fullscreen/FullscreenDisableIconComponent";
import { FullscreenEnableIconComponent } from "../../..//icons/fullscreen/FullscreenEnableIconComponent";
import { SocialShareIconComponent } from "../../../icons/socialShare/SocialShareIconComponent";
import { SubtitlesIconComponent } from "../../../icons/subtitles/SubtitlesIconComponent";
import { VolumeLoudIconComponent } from "../../../icons/volume/VolumeLoudIconComponent";
import { MenuButtonComponent } from "../common/MenuButtonComponent";

import "@styles/c-mobileMenu.scss";

interface Props {
  isSocialShareDisplayed: boolean;
  onSocialShareClicked: () => void;

  isFullscreenSupported: boolean;
  isFullscreen: boolean;
  onToggleFullscreen: () => void;

  isVolumeMuted: boolean;
  onToggleMuted: () => void;

  hasSubtitles: boolean;
  selectedSubtitlesSrc?: string;
  onSubtitlesSelectorClicked: () => void;

  isDisabled?: boolean;
}

export const MobileMenuComponent: React.SFC<Props> = (props) => {
  const {
    isSocialShareDisplayed,
    onSocialShareClicked,

    isFullscreenSupported,
    isFullscreen,
    onToggleFullscreen,
    
    isVolumeMuted,
    onToggleMuted,

    hasSubtitles,
    selectedSubtitlesSrc,
    onSubtitlesSelectorClicked,

    isDisabled

  } = props;

  return (
    <div className="c-mobileMenu">
      {isSocialShareDisplayed &&
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onSocialShareClicked}
          icon={<SocialShareIconComponent />}
          isActive={!!selectedSubtitlesSrc}
        />
      }
      {hasSubtitles &&
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onSubtitlesSelectorClicked}
          icon={<SubtitlesIconComponent />}
          isActive={!!selectedSubtitlesSrc}
        />
      }

      {(isFullscreenSupported || (!isFullscreenSupported && window.self === window.top)) &&
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onToggleFullscreen}
          icon={isFullscreen ? <FullscreenDisableIconComponent /> : <FullscreenEnableIconComponent />}
        /> 
      }

      {!isVolumeMuted &&
        <MenuButtonComponent
          className="c-mobileMenu__item"
          onClick={isDisabled ? () => {} : onToggleMuted}
          icon={<VolumeLoudIconComponent />}
        />
      }
    </div>
  );
};
